export default __webpack_public_path__ + "static/media/17.be9fc12d.svg";